const binding = { modules: {}, dataActions: {} };

    (binding.modules['ecomm-button'] = {
        c: () => require('partner/modules/ecomm-button/ecomm-button.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'ecomm-button',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/ecomm-button'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|ecomm-button|ecomm-button'] = {
                c: () => require('partner/modules/ecomm-button/ecomm-button.view.tsx'),
                cn: '__local__-__local__-ecomm-button'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };